import { CoreEvent, eventNames } from '@carvana/core-events';
import { useContext, useEffect } from 'react';
import FinanceContext from '~/context/srp/FinanceContext';

export default function useEventListeners() {
  const { setShouldRefreshSoftPull } = useContext(FinanceContext);

  useEffect(() => {
    function refreshWithFinancing() {
      setShouldRefreshSoftPull(true);
    }

    CoreEvent.on(eventNames.softpullModal.success, refreshWithFinancing);

    return () => {
      CoreEvent.off(eventNames.softpullModal.success, refreshWithFinancing);
    };
  }, [setShouldRefreshSoftPull]);
}
